import styled, { css } from 'styled-components';
import { layout, media, remCalc } from '@prisjakt/ui-base';
import StoreLogoComponent from '@prisjakt/ui-store-logo';
import InfoListComponent from '@prisjakt/ui-info-list';

import { MAIN_TITLE_SIZE, mobileLogoWidth } from '../../constants';

export const Header = styled.header`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-bottom: 1px solid ${p => p.theme.lines.secondary};
  padding: ${layout.measurements.spacing050};
  padding-bottom: ${layout.measurements.spacing100};
  margin: 0 ${layout.measurements.spacing050};

  @supports (display: grid) {
    display: grid;
    grid-template-columns: 1fr 30%;
    row-gap: ${layout.measurements.spacing025};
    column-gap: ${layout.measurements.spacing050};
  }

  ${media.smallOnly`
    margin: 0;
    padding-left: ${layout.measurements.spacing100};
    padding-right: ${layout.measurements.spacing100};
  `}

  ${media.mediumDown`
    @supports (display: grid) {
      grid-template-columns: 1fr auto;
    }
  `}
`;

export const TitleWrapper = styled.ul(
  props => css`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: ${layout.measurements.spacing050};

    li {
      display: flex;
      align-items: center;
      margin-right: ${layout.measurements.spacing050};

      &:last-child {
        margin: 0;
      }

      &::before {
        content: '|';
        margin-right: ${layout.measurements.spacing050};
        color: ${props.theme.lines.secondary};
      }

      ${media.mediumUp`
        &:first-child:before {
          display: none;
        }
      `}

      ${media.smallOnly`
        &:first-child {
          width: 100%;
          margin: 0;
          margin-bottom: ${layout.measurements.spacing050};
        }

        &:not(:last-child)::before {
          display: none;
        }
      `}
    }
  `
);

export const Title = styled.h1`
  font-size: ${remCalc(MAIN_TITLE_SIZE)};
  margin: 0;
  margin-right: ${layout.measurements.spacing050};
`;

export const StoreLogo = styled(StoreLogoComponent)`
  margin-bottom: ${layout.measurements.spacing050};

  ${media.smallOnly`
      max-width: ${mobileLogoWidth}px;
    `}
`;

export const StoreInfoWrapper = styled.div`
  flex: 1 0 auto;
`;

export const TitleAndLogoWrapper = styled.div`
  flex: 0 0 50%;
`;

export const CountryText = styled.span``;

export const RatingCount = styled.p(
  props => css`
    margin: 0 0 0 ${layout.measurements.spacing025};
    font-size: ${layout.measurements.fontSizeSmall};
    color: ${props.theme.text.quaternary};
  `
);

export const InfoList = styled(InfoListComponent)`
  @supports (display: grid) {
    grid-area: 2 / 1 / 3 / 3;
  }
`;

export const SotyBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
